import React, { Component } from 'react';
import { Utils } from '../../utils/utils';
import Sdk from 'api.digitalpages.module.sdk.api';
import AuthorService from '../../services/AuthorService';
import Slider from "react-slick";
import './shelf-recent-readings.css';

export default class ShelfRecentReadings extends Component {
  constructor(props) {
    super(props);
    this.sliderRef = React.createRef();

    this.state = {
      "recent_readings": null,
      "currentSlide": 0,
      "totalSlides": 0,
      "loading": true,
      "authors": []
    };
  }

  componentWillMount() {
    this.getRecentReadings();
  }

  componentDidMount() {

  }

  async getRecentReadings() {
    var _this = this;
    this.setState({ "loading": true });

    // Carregar autores e livros em paralelo
    const [authors, response] = await Promise.all([
      AuthorService.loadAuthors(),
      Utils.bridgeAndStore(`/cms/v1.1/managed/content/history?page_size=18&order=desc&include_properties=true&include_entities=true&include_references=true`)
    ]);

    var recentReadings = response.result;

    for (var i = 0; i < recentReadings.length; i++) {
      recentReadings[i].interactions = await _this.getBookInteractions(recentReadings[i].uid);
      // Adicionar autor usando o AuthorService
      recentReadings[i].author = _this.getBookAuthor(recentReadings[i], authors);
    }

    this.setState({
      "recent_readings": recentReadings,
      "authors": authors,
      "loading": false
    })
  }

  getBookAuthor = (book, authors) => {
    // Primeiro tentar buscar autor nas properties
    let author = book.properties?.find(p =>
      p.name === "Autor" ||
      p.name === "autor" ||
      p.name === "Author" ||
      p.name === "AUTOR"
    )?.value;

    // Se não encontrou nas properties, usar a lógica baseada em entities
    if (!author && book.entities && authors.length) {
      author = AuthorService.updateContentAuthor(book, authors);
    }

    // Fallbacks adicionais
    if (!author || author === 'Autor não disponível') {
      author = book.author ||
        book.properties?.find(p => p.name.toLowerCase().includes('autor'))?.value ||
        'Autor não informado';
    }

    return author;
  }

  async getBookInteractions(uid) {
    var response = await Utils.bridgeAndStore(`/cms/v1.1/managed/content/group/uid/${uid}/interactions`);
    return response;
  }

  getImageUrl(uid) {
    var url = `${Sdk.Api.domain}/cms/v1.1/managed/content/group/uid/${uid}/default/thumb?image_options=width:200&api_env=${Sdk.Api.enviroment}&project_key=${Sdk.Api.projectKey}&access_token=${Sdk.Api.authorization.credential.accessToken}`;

    return url;
  }

  next = () => {
    this.sliderRef.current.slickNext();
  };

  previous = () => {
    this.sliderRef.current.slickPrev();
  };

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  getProgress(interactions) {
    var progress = null;
    var progressObj = interactions.find(interaction => interaction.activity_data && interaction.activity_data.search("exact_progress") > -1);
    if (progressObj) progress = progressObj.interaction_progress;

    return progress;
  }

  render() {
    var _this = this;
    const {
      recent_readings,
      loading
    } = this.state;

    var popularSettings = {
      className: "slider variable-width",
      dots: false,
      infinite: false,
      centerMode: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 5,
      variableWidth: true,
      afterChange: (current) => {
        const totalSlides = Math.ceil((recent_readings?.length || 0) / 5);
        this.setState({ currentSlide: current, totalSlides });
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            variableWidth: true
          }
        }
      ],
    };

    return (
      <div className="shelf-recent-readings">
        <div className="shelf-recent-readings-header">
          <div className="shelf-recent-readings-header-left">
            <span className="shelf-recent-readings-header-icon"></span>
            <span className="shelf-recent-readings-header-title" role="heading" aria-level="2">Leituras recentes</span>
          </div>

          <div className="shelf-recent-readings-header-right">
            <button
              className={`shelf-recent-readings-header-btn-left ${this.state.currentSlide === 0 ? 'disabled' : 'enabled'}`}
              onClick={this.previous}
            >
              Anterior
            </button>
            <button
              className={`shelf-recent-readings-header-btn-right ${this.state.currentSlide >= recent_readings?.length - (window.innerWidth <= 767 ? 2 : 5) ? 'disabled' : 'enabled'}`}
              onClick={this.next}
            >
              Próximo
            </button>
          </div>
        </div>
        <div className="shelf-recent-readings-content">
          <Slider ref={this.sliderRef} {...popularSettings}>
            {loading ? (
              Array.from({ length: 5 }, (_, index) => (
                <div key={index} className="shelf-recent-readings-card skeleton">
                  <div className="shelf-recent-readings-card-thumb skeleton-cover"></div>
                  <div className="shelf-recent-readings-card-title skeleton-title"></div>
                  <div className="shelf-recent-readings-card-title skeleton-title" style={{marginTop: '10px', height: "28px"}}></div>
                  <div className="shelf-recent-readings-card-edition skeleton-edition"></div>
                </div>
              ))
            ) : (
              recent_readings && recent_readings.map(function (item, index) {
                return <div
                  className={`shelf-recent-readings-card`}
                  key={item.uid}
                  onClick={() => _this.redirectTo(`/book/${item.uid}`)}
                >
                  <img
                    className="shelf-recent-readings-card-thumb blur"
                    src={_this.getImageUrl(item.uid)}
                    loading="lazy"
                    onLoad={(e) => e.target.classList.add('loaded')}
                    alt={`Imagem de capa do livro ${item.edition}`}
                  />
                  <div className="shelf-recent-readings-card-title">
                    {item.name}
                  </div>
                  <div className="shelf-recent-readings-card-title" style={{marginTop: '10px', fontWeight: '1000', fontSize: '10px', height: "28px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "200px"}}> 
                    {item.author}
                  </div>
                  <div className="shelf-recent-readings-card-edition">
                    {item.edition}
                  </div>
                  {_this.getProgress(item.interactions) !== null && _this.getProgress(item.interactions) > 0 &&
                    <div className="shelf-recent-readings-card-progress">
                      {_this.getProgress(item.interactions)}%
                    </div>
                  }
                </div>
              })
            )}
          </Slider>
        </div>

      </div>
    );
  }
}
